module.exports = __webpack_public_path__ + "static/media/under_construction.8be16a10.svg";